<app-skeleton-template *ngIf="!loadTabs" [template]="skeletonTemplate"></app-skeleton-template>

<div @fadeInAnimation class="appointment-container" *ngIf="loadTabs">
  <div class="title-section mb-xlg">
    <h2 class="text-title-md-bold">Asesoría</h2>
  </div>

  <div class="card-container-tabs">

    <div class="card-content-tabs">
      <div class="tw-flex tw-flex-col">
        <nz-steps [nzCurrent]="currentIndex" class="tw-mb-0 tw-pb-4 shepherd-steps">
          <nz-step class="shepherd-step-1" nzTitle="Información"></nz-step>
          <nz-step class="shepherd-step-2" nzTitle="Fichas"></nz-step>
          <nz-step class="shepherd-step-3" nzTitle="Mediciones"></nz-step>
          <nz-step class="shepherd-step-4" nzTitle="Fórmulas"></nz-step>
          <nz-step class="shepherd-step-5" nzTitle="Diagnóstico"></nz-step>
          <nz-step class="shepherd-step-6" nzTitle="Orientación alimenticia"></nz-step>
          <nz-step class="shepherd-step-7" nzTitle="Descargar informe"></nz-step>
        </nz-steps>
        <div class="tw-flex tw-items-center tw-mb-2" [class.tw-justify-between]="currentIndex > 0" [class.tw-justify-end]="currentIndex === 0">
          <button nz-button nzType="text" class="tw-text-teal-700 shepherd-patient-information-btn-back" (click)="pre()" *ngIf="currentIndex > 0">
            <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
            <span>Anterior</span>
          </button>
          <button nz-button nzType="text" class="tw-text-teal-700 shepherd-patient-information-btn-next" (click)="next()" *ngIf="currentIndex < 6">
            <span>Siguiente <span nz-icon nzType="arrow-right" nzTheme="outline"></span></span>
          </button>
        </div>
      </div>
      <router-outlet (activate)="this.routerOutlet($event)"></router-outlet>
    </div>
  </div>
</div>
